var _rect, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#EBF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.166 8.33333C10.166 7.04467 11.2107 6 12.4993 6H19.4993C20.788 6 21.8327 7.04467 21.8327 8.33333V12.0953L20.5222 11.2375C19.5104 10.5752 18.186 10.6456 17.2501 11.4114L14.1945 13.9114C13.5542 14.4353 12.648 14.4835 11.9557 14.0304L10.166 12.8589V8.33333ZM20.043 11.9696L21.8327 13.141V15.3333C21.8327 16.622 20.788 17.6667 19.4993 17.6667H12.4993C11.2107 17.6667 10.166 16.622 10.166 15.3333V13.9047L11.4765 14.7625C12.4883 15.4247 13.8127 15.3544 14.7486 14.5886L17.8042 12.0886C18.4446 11.5646 19.3507 11.5165 20.043 11.9696ZM13.9577 11.25C14.7631 11.25 15.416 10.5971 15.416 9.79167C15.416 8.98625 14.7631 8.33333 13.9577 8.33333C13.1523 8.33333 12.4993 8.98625 12.4993 9.79167C12.4993 10.5971 13.1523 11.25 13.9577 11.25Z",
    fill: "#A4C6F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.666,
    cy: 7.5,
    r: 2.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.666 5C20.2853 5 19.166 6.11929 19.166 7.5C19.166 8.88071 20.2853 10 21.666 10C23.0467 10 24.166 8.88071 24.166 7.5C24.166 6.11929 23.0467 5 21.666 5ZM21.4785 8.5C21.4785 8.60355 21.5625 8.6875 21.666 8.6875C21.7696 8.6875 21.8535 8.60355 21.8535 8.5L21.8535 8.25C21.8535 8.14645 21.7696 8.0625 21.666 8.0625C21.5625 8.0625 21.4785 8.14645 21.4785 8.25L21.4785 8.5ZM21.4785 7.625C21.4785 7.72855 21.5625 7.8125 21.666 7.8125C21.7696 7.8125 21.8535 7.72855 21.8535 7.625L21.8535 6.5C21.8535 6.39645 21.7696 6.3125 21.666 6.3125C21.5625 6.3125 21.4785 6.39645 21.4785 6.5L21.4785 7.625Z",
    fill: "#619BF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.968ced65ce2c1c7951cc80194bbc48cb.svg";
export { ForwardRef as ReactComponent };